import React from "react";
import HelpLink, { GUIDE_URLS } from "@/components/HelpLink";

export const CONTEXT_BADGE = {
  support_equipe: { label: "Support & diagnostic", color: "bg-emerald-100 text-emerald-800" },
  idees_evolutions: { label: "Idées & évolutions", color: "bg-amber-100 text-amber-800" },
  cadrage_evolutions: { label: "Cadrage", color: "bg-indigo-100 text-indigo-800" },
};

export default function ContextPicker({
  contexts,
  persona = "unknown",
  onPick,
  onMyRequests,
  compact = false,
}) {
  return (
    <div className={compact ? "agent-picker p-4" : "agent-picker max-w-3xl mx-auto p-6"}>
      {!compact && (
        <div className="agent-picker-header mb-8 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h1 className="text-2xl font-bold mb-1">Assistant</h1>
            <p className="text-sm text-gray-600">
              Choisis le mode qui correspond à ce que tu veux faire.
            </p>
            {persona !== "unknown" && (
              <p className="text-xs text-gray-500 mt-2">
                Connecté en tant que : <span className="font-medium capitalize">{persona}</span>
              </p>
            )}
          </div>
          <HelpLink url={GUIDE_URLS.assistant} />
        </div>
      )}
      {compact && persona !== "unknown" && (
        <p className="text-xs text-gray-500 mb-3">
          Connecté en tant que : <span className="font-medium capitalize">{persona}</span>
        </p>
      )}
      <div className={compact ? "grid gap-3 grid-cols-1" : "grid gap-4 sm:grid-cols-2"}>
        {contexts.map((c) => {
          const badge = CONTEXT_BADGE[c.name] || { label: c.label, color: "bg-gray-100 text-gray-800" };
          return (
            <button
              key={c.name}
              onClick={() => onPick(c.name)}
              className="agent-context-card text-left p-5 border rounded-lg hover:shadow-md transition bg-white"
            >
              <div className="flex items-center justify-between mb-2">
                <span className={`text-xs px-2 py-1 rounded ${badge.color}`}>{badge.label}</span>
                {c.status === "completed" ? (
                  <span className="text-xs px-2 py-0.5 rounded bg-green-100 text-green-800">
                    ✓ Terminé
                  </span>
                ) : c.n_answered > 0 && c.n_questions > 0 ? (
                  <span className="text-xs text-gray-500">
                    {c.n_answered}/{c.n_questions} répondues
                  </span>
                ) : c.n_questions > 0 ? (
                  <span className="text-xs text-gray-500">{c.n_questions} questions</span>
                ) : null}
              </div>
              <p className="text-sm text-gray-700">{c.description}</p>
              {c.status === "completed" && (
                <p className="text-xs text-orange-600 mt-2">
                  → Clique pour modifier / compléter tes réponses
                </p>
              )}
              {c.status === "active" && c.n_answered > 0 && (
                <p className="text-xs text-orange-600 mt-2">
                  → Clique pour continuer
                </p>
              )}
            </button>
          );
        })}
      </div>
      <div className="mt-6">
        <button
          onClick={onMyRequests}
          className="text-sm text-orange-600 hover:text-orange-700 font-medium"
        >
          📋 Voir mes demandes →
        </button>
      </div>
    </div>
  );
}
